import XFetch from "../../common/x-fetch"

// --- admin actions --- //
//  these have nothing to do with document state 
//  so we keep them out of Redux

let AdminAPI = {}

AdminAPI.makeNewUser = (user) => {
  return XFetch.post(`/api/new_user`, user)
}

export default Object.freeze(AdminAPI)
